import {
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuRoot,
  ContextMenuTrigger,
} from "@/components/ui/shadcn/ContextMenu/ContextMenuPrimitives";
import { type Header } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, EyeOff } from "lucide-react";
import { type ReactElement } from "react";

type TableHeaderContextMenuProps<TData> = {
  header: Header<TData, unknown>;
  trigger: ReactElement;
};

/** Context menu shared by every draggable table header. */
export function TableHeaderContextMenu<TData>({
  header,
  trigger,
}: TableHeaderContextMenuProps<TData>) {
  const canSort = header.column.getCanSort();
  const canHide = header.column.getCanHide();

  return (
    <ContextMenuRoot>
      <ContextMenuTrigger asChild>{trigger}</ContextMenuTrigger>
      <ContextMenuContent>
        <ContextMenuItem
          disabled={!canSort}
          onSelect={() => {
            header.column.toggleSorting(false);
          }}
        >
          <ArrowUp />
          Sort ascending
        </ContextMenuItem>
        <ContextMenuItem
          disabled={!canSort}
          onSelect={() => {
            header.column.toggleSorting(true);
          }}
        >
          <ArrowDown />
          Sort descending
        </ContextMenuItem>
        <ContextMenuItem
          disabled={!canHide}
          onSelect={() => {
            header.column.toggleVisibility(false);
          }}
        >
          <EyeOff />
          Hide column
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenuRoot>
  );
}
